import { render } from "./RegistGroupClassEduPay.vue?vue&type=template&id=df973c56"
import script from "./RegistGroupClassEduPay.vue?vue&type=script&lang=js"
export * from "./RegistGroupClassEduPay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__